module.exports = __webpack_public_path__ + "img/hashtag_black.3a1b8cfa.svg";